import { omit } from 'lodash';
export class AppSegmentationBasicModel {
    constructor(payload) {
        Object.assign(this, omit(payload, '__typename'));
    }
}
